<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const DISMISS_KEY = 'atende_whats_new_v1_dismissed';
// Assets do public dir: bind dinâmico (:src) para o Vite servir por URL em
// runtime — src estático quebra o build (Rollup tenta resolver como módulo).
// ?v=atende2: quebra o cache longo (~1 ano) do logo antigo do Chatwoot que
// clientes cachearam antes do rebranding. Bump o token ao trocar o logo.
const LOGO_LIGHT = '/brand-assets/logo.svg?v=atende2';
const LOGO_DARK = '/brand-assets/logo_dark.svg?v=atende2';

const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

const dialogRef = ref(null);
// Endereco das novidades vem da instalacao (ATENDE_NOVIDADES_URL); vazio = sem aviso.
const globalConfig = useMapGetter('globalConfig/get');
const novidadesUrl = computed(() => globalConfig.value?.novidadesUrl);

onMounted(() => {
  if (novidadesUrl.value && !uiSettings.value?.[DISMISS_KEY]) {
    dialogRef.value?.open();
  }
});

const markDismissed = () => {
  updateUISettings({ [DISMISS_KEY]: true });
};

const viewUpdates = () => {
  window.open(novidadesUrl.value, '_blank', 'noopener');
  dialogRef.value?.close();
};
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="sm"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="markDismissed"
  >
    <div class="flex flex-col items-center gap-4 text-center">
      <img :src="LOGO_LIGHT" alt="Atende" class="h-10 dark:hidden" />
      <img :src="LOGO_DARK" alt="Atende" class="hidden h-10 dark:block" />
      <div class="flex flex-col gap-2">
        <h3 class="text-lg font-medium leading-6 text-n-slate-12">
          {{ t('WHATS_NEW.ATENDE_REBRAND.TITLE') }}
        </h3>
        <p class="mb-0 text-sm text-n-slate-11">
          {{ t('WHATS_NEW.ATENDE_REBRAND.DESCRIPTION') }}
        </p>
      </div>
    </div>
    <template #footer>
      <div class="flex flex-col w-full gap-2">
        <Button
          color="blue"
          :label="t('WHATS_NEW.ATENDE_REBRAND.VIEW_UPDATES')"
          class="w-full"
          @click="viewUpdates"
        />
        <Button
          variant="ghost"
          color="slate"
          :label="t('WHATS_NEW.ATENDE_REBRAND.DISMISS')"
          class="w-full"
          @click="dialogRef?.close()"
        />
      </div>
    </template>
  </Dialog>
</template>
